import { ECheckEmailStatus, EAuthenticateStatus, ERestoreStatus } from '../../types/authentication';
import { ERequestStatus } from '../../types/requestStatus';
export var defaultState = {
  checkEmail: {
    status: ECheckEmailStatus.Initial
  },
  authenticate: {
    status: EAuthenticateStatus.Initial
  },
  twoFactor: {
    phoneState: {
      status: ERequestStatus.Initial,
      phone: '',
      secondsToRetry: null,
      senderType: null,
      isAutosubmitEnabled: true,
      error: null
    }
  },
  restore: {
    status: ERestoreStatus.Initial
  },
  password: ''
};